<template>
  <div class="router">
    <div class="card">
      <div class="card-header">新增医生</div>
      <div class="main">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item
            label="医院名称"
            prop="title"
            :rules="[{ required: true, message: '医院名称不能为空' }]"
          >
            <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item
            label="姓名"
            prop="username"
            :rules="[{ required: true, message: '医生姓名不能为空' }]"
          >
            <el-input v-model="form.username"></el-input>
          </el-form-item>
          <el-form-item
            label="手机号"
            prop="phone"
            :rules="[{ required: true, message: '手机号不能为空' }]"
          >
            <el-input v-model="form.phone"></el-input>
          </el-form-item>

          <el-form-item
            label="登陆密码"
            prop="password"
            :rules="[{ required: true, message: '登陆密码不能为空' }]"
          >
            <el-input v-model="form.password"></el-input>
          </el-form-item>

          <el-form-item
            label="管理员"
            prop="is_super"
          >
            <el-switch v-model="form.is_super" active-value="1" inactive-value="0"></el-switch>
          </el-form-item>

          <el-form-item label="二维码" prop="qrcode">
            <el-upload
              class="upload-demo"
              :action="action"
              :headers="headers"
              :data="update_info"
              :on-success="qrcodeSuccess"
              :on-remove="qrcodeRemove"
              list-type="picture"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件，且不超过500kb
              </div>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit('form')"
              >立即创建</el-button
            >
            <el-button>取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { update_info, UPLOAD_URL } from '../../untils/js/common'
  export default {
    components: {},
    name: 'add-admin',
    data() {
      return {
        data: {},
        action: UPLOAD_URL,
        headers: { token: localStorage.getItem('token') },
        update_info: update_info(),
        form: {
          title: '',
          phone: '',
          username: '',
          qrcode: '',
          is_super: 0,
          password: '',
        },
      }
    },
    mounted() {
    },
    methods: {
      _create() {
        this.$request('/member', this.form, 'POST').then((res) => {
          if (res.error_code === 10000) {
            this.$message.success('添加成功')
            this.$store.commit('close_tab', 'add-admin')
          }
        })
      },
      onSubmit(form) {
        this.$refs[form].validate((valid) => {
          if (valid) {
            this._create()
          } else {
            return false
          }
        })
      },
      qrcodeSuccess(e) {
        this.form.qrcode = e.data
      },
      qrcodeRemove() {
        this.form.qrcode = ''
      }
    },
  }
</script>

<style scoped>
  .main {
    margin-top: 20px;
    padding: 0px 30px;
  }

  .add {
    width: 100%;
    height: 100px;
    display: flex;
    justify-content: center;
  }

  .add-button {
    height: 36px;
    margin: auto;
  }

  .input {
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    display: inline-block;
    font-size: inherit;
    height: 40px;
    line-height: 40px;
    outline: none;
    padding: 0 15px;
    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 100%;
  }
</style>
